import Cookies from "js-cookie";

export const baseUrl = process.env.REACT_APP_API + "/api";

export const getAuthHeader = () => {
  const token = Cookies.get("AUTH_TOKEN");
  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
};

export const WRITE_CONTROL_BASE = baseUrl + "/write-control";
export const EXEC_BASE          = baseUrl + "/write-control/execution";

// ── Writable parameters ───────────────────────────────────────────────────────
export const writeParamsUrl = (assetUuid) =>
  `${WRITE_CONTROL_BASE}/assets/${assetUuid}/write-parameters`;

// ── Procedures ────────────────────────────────────────────────────────────────
export const proceduresUrl       = (assetUuid) => `${WRITE_CONTROL_BASE}/assets/${assetUuid}/procedures`;
export const procedureByUuidUrl  = (uuid)       => `${WRITE_CONTROL_BASE}/procedures/${uuid}`;

// ── Publish ───────────────────────────────────────────────────────────────────
export const PUBLISH_URL = `${WRITE_CONTROL_BASE}/publish`;

// ── Audit logs ────────────────────────────────────────────────────────────────
export const logsUrl = (assetUuid) => `${WRITE_CONTROL_BASE}/assets/${assetUuid}/logs`;

// ── Execution ─────────────────────────────────────────────────────────────────
export const EXECUTION_START_URL          = `${EXEC_BASE}/start`;
export const executionPauseUrl  = (uuid)  => `${EXEC_BASE}/${uuid}/pause`;
export const executionResumeUrl = (uuid)  => `${EXEC_BASE}/${uuid}/resume`;
export const executionStopUrl   = (uuid)  => `${EXEC_BASE}/${uuid}/stop`;
export const executionStatusUrl = (uuid)  => `${EXEC_BASE}/${uuid}/status`;
export const activeExecutionUrl = (assetUuid) => `${EXEC_BASE}/asset/${assetUuid}/active`;

// ── Lock ──────────────────────────────────────────────────────────────────────
export const lockAcquireUrl   = (assetUuid) => `${EXEC_BASE}/lock/${assetUuid}/acquire`;
export const lockHeartbeatUrl = (assetUuid) => `${EXEC_BASE}/lock/${assetUuid}/heartbeat`;
export const lockReleaseUrl   = (assetUuid) => `${EXEC_BASE}/lock/${assetUuid}/release`;
export const lockStatusUrl    = (assetUuid) => `${EXEC_BASE}/lock/${assetUuid}`;

// ── Session ───────────────────────────────────────────────────────────────────
export const sessionAcceptUrl    = (sid) => `${EXEC_BASE}/session/${sid}/accept`;
export const sessionRejectUrl    = (sid) => `${EXEC_BASE}/session/${sid}/reject`;
export const sessionHeartbeatUrl = (sid) => `${EXEC_BASE}/session/${sid}/heartbeat`;
export const sessionForceUrl     = (sid) => `${EXEC_BASE}/session/${sid}/force`;